import * as types from "../constants/stWorkflowConstants"

const initialState = {
    isConfirmationModal: {
        modal: false,
        id: null
    },
}

export default function StWorkflowReducer(state=initialState, action) {
    switch(action.type) {
        case types.ST_WORKFLOW_IS_CONFIRMATION_MODAL:
            return {
                isConfirmationModal: action.payload.isConfirmationModal,
            }
        default:
            return state
    }
}